/* eslint-disable angular/controller-name, angular/controller-as */

/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
angular.
module("digiexam").
controller("ShareItemController", function ShareItemController(
	$scope,

	dxApi,
	dxSession,
	DX_SHARE,

	dxDialog,
	dxLocalize
) {
	"use strict";

	$scope.loading = false;
	$scope.email = "";

	$scope.close = function close() {
		dxDialog.closeMostRecent();
	};

	$scope.clearErrors = function clearErrors() {
		$scope.error = "";
	};

	// Helpers

	$scope.getDialogTitle = function getDialogTitle() {
		var s = dxLocalize.get("DoYouWantToShareX");
		return s.replace("%v", $scope.item.displayName);
	};

	$scope.getDialogBodyText = function getDialogBodyText() {
		var s = dxLocalize.get("EnterTheEmailAdressYouWantToShareWith");
		return s.replace("%v", $scope.item.displayName);
	};

	$scope.isUserEmail = function isUserEmail(sharingEmail) {
		var usr = dxSession.getUser();
		for (var i = 0; i < usr.email.length; i++) {
			if (usr.email[i] === sharingEmail) {
				$scope.error = dxLocalize.get("YouCantShareToYourOwnMail");
				return true;
			}
		}
		return false;
	};

	$scope.isShared = function isShared() {
		return $scope.sharedToUser.length > 0;
	};

	$scope.isOwner = function isOwner() {
		return $scope.item.ownerId === dxSession.getUser().id;
	};

	$scope.getOwner = function getOwner() {
		if (!$scope.ownerName) {
			return dxLocalize.get("ThisUserIsDeleted");
		}

		return $scope.ownerName;
	};

	$scope.removeAccess = function removeAccess(userId, index) {
		function spliceUser(i, num) {
			$scope.sharedToUser.splice(index, num);
		}

		switch ($scope.type) {
			case DX_SHARE.EXAM_TEMPLATES:
				dxApi.v1.examTemplates.shares.delete($scope.examId, userId).then(spliceUser(index, 1));
				break;
			case DX_SHARE.RUBRIC:
				dxApi.v1.rubrics.shares.delete($scope.rubricId, userId).then(spliceUser(index, 1));
				break;
			default:
				return;
		}
	};
});
